import React from "react";

type TabItem = {
  label: string;
  value: string;
};

type TabsProps = {
  items: TabItem[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
};

const Tabs: React.FC<TabsProps> = ({ items, value, onChange, className }) => {
  return (
    <div className={`w-full border-b border-[#E6E8EC] ${className || ""}`}>
      <div className="flex items-center gap-6">
        {items.map((item) => {
          const isActive = item.value === value;
          return (
            <button
              key={item.value}
              type="button"
              className={`relative py-2 text-sm font-[600] cursor-pointer whitespace-nowrap ${
                isActive ? "text-[#73B5C5]" : "text-[#6C6C6C] hover:text-[#1E1E1E]"
              }`}
              onClick={() => onChange(item.value)}
            >
              {item.label}
              {isActive && (
                <span className="absolute -bottom-[1px] left-0 right-0 h-[2px] bg-[#73B5C5]" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
